import { render, staticRenderFns } from "./PaymentTerm.vue?vue&type=template&id=b822e66c&scoped=true&"
import script from "./PaymentTerm.vue?vue&type=script&lang=js&"
export * from "./PaymentTerm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTerm.vue?vue&type=style&index=0&id=b822e66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b822e66c",
  null
  
)

component.options.__file = "PaymentTerm.vue"
export default component.exports